<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 486 6" fill="none">
    <g filter="url(#filter0_i_169_9615)" shape-rendering="geometricPrecision">
      <path
        d="M243 0H486V1.68026C464 2.80043 10.5 11.7618 0 0H243Z"
        :fill="mainFeatureColor"
        stroke-linejoin="round"
        shape-rendering="geometricPrecision"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_169_9615"
        x="0"
        y="0"
        width="491"
        height="8"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="19" dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_169_9615" />
      </filter>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { useLetterFileColor } from "../composable/useLetterFileColor";

const { mainFeatureColor } = useLetterFileColor();
</script>
